import React from 'react';
import { motion } from 'framer-motion';
export function Booking() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-432">
      <div className="max-w-2xl mx-auto" data-id="element-433">
        <header className="mb-16 text-center" data-id="element-434">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-4 block text-black/40" data-id="element-435">
            Bespoke Experience
          </span>
          <h1 className="text-lg sm:text-4xl md:text-5xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-436">
            Book a Consultation
          </h1>
          <p className="text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase px-4 md:px-0" data-id="element-437">
            Schedule a private session at our Alexandria studio for bespoke
            tailoring, bridal consultations, or a personalized styling
            experience.
          </p>
        </header>

        <form className="space-y-12" data-id="element-438">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-439">
            <div className="space-y-2" data-id="element-440">
              <label className="text-xs font-display tracking-widest uppercase text-black/40" data-id="element-441">
                Full Name
              </label>
              <input type="text" className="w-full border-b border-grey-divider py-3 focus:outline-none focus:border-black transition-colors" data-id="element-442" />
            </div>
            <div className="space-y-2" data-id="element-443">
              <label className="text-xs font-display tracking-widest uppercase text-black/40" data-id="element-444">
                Email Address
              </label>
              <input type="email" className="w-full border-b border-grey-divider py-3 focus:outline-none focus:border-black transition-colors" data-id="element-445" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-446">
            <div className="space-y-2" data-id="element-447">
              <label className="text-xs font-display tracking-widest uppercase text-black/40" data-id="element-448">
                Service Type
              </label>
              <select className="w-full border-b border-grey-divider py-3 focus:outline-none focus:border-black transition-colors bg-transparent appearance-none" data-id="element-449">
                <option data-id="element-450">Bespoke Tailoring</option>
                <option data-id="element-451">Bridal Consultation</option>
                <option data-id="element-452">Personal Styling</option>
                <option data-id="element-453">Collection Preview</option>
              </select>
            </div>
            <div className="space-y-2" data-id="element-454">
              <label className="text-xs font-display tracking-widest uppercase text-black/40" data-id="element-455">
                Preferred Date
              </label>
              <input type="date" className="w-full border-b border-grey-divider py-3 focus:outline-none focus:border-black transition-colors" data-id="element-456" />
            </div>
          </div>

          <div className="space-y-2" data-id="element-457">
            <label className="text-xs font-display tracking-widest uppercase text-black/40" data-id="element-458">
              Additional Notes
            </label>
            <textarea rows={4} className="w-full border-b border-grey-divider py-3 focus:outline-none focus:border-black transition-colors resize-none" data-id="element-459" />
          </div>

          <button className="w-full bg-black text-white py-5 text-xs font-display font-bold uppercase tracking-[0.3em] hover:bg-black/80 transition-colors" data-id="element-460">
            Request Appointment
          </button>
        </form>

        <div className="mt-16 pt-12 border-t border-grey-divider text-center" data-id="element-461">
          <p className="text-xs font-display tracking-widest uppercase text-black/40 mb-4" data-id="element-462">
            Direct Inquiries
          </p>
          <a href="tel:5718423307" className="text-lg font-display tracking-widest uppercase hover:opacity-50 transition-opacity" data-id="element-463">
            (571) 842-3307
          </a>
        </div>
      </div>
    </div>;
}